import { LANGUAGE_FR, LANGUAGE_DE } from './languages';

export const GIFT_CARDS_VIEW_MODE_DE = {
  PURCHASE: 'bestellen',
  BALANCE: 'saldo',
} as const;

export const GIFT_CARDS_VIEW_MODE_FR = {
  PURCHASE: 'commander',
  BALANCE: 'solde',
} as const;

export const GIFT_CARDS_VIEW_MODES_DE = Object.values(GIFT_CARDS_VIEW_MODE_DE);

export const GIFT_CARDS_VIEW_MODES_FR = Object.values(GIFT_CARDS_VIEW_MODE_FR);

export const GIFT_CARDS_VIEW_MODES = {
  [LANGUAGE_DE]: GIFT_CARDS_VIEW_MODES_DE,
  [LANGUAGE_FR]: GIFT_CARDS_VIEW_MODES_FR,
};

export const GIFT_CARDS_VIEW_MODE = {
  [LANGUAGE_DE]: GIFT_CARDS_VIEW_MODE_DE,
  [LANGUAGE_FR]: GIFT_CARDS_VIEW_MODE_FR,
};

export const DELIVERY_OPTIONS = {
  TO_MY_HOME: false,
  TO_THE_RECIPIENT: true,
};
